import { render, staticRenderFns } from "./VersionIndexDetailDialog.vue?vue&type=template&id=4c51daec&scoped=true&"
import script from "./VersionIndexDetailDialog.vue?vue&type=script&lang=js&"
export * from "./VersionIndexDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./VersionIndexDetailDialog.vue?vue&type=style&index=0&id=4c51daec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51daec",
  null
  
)

export default component.exports